import { Entity } from '@backstage/catalog-model';

/**
 * Decodes a base64 payload stored on a DaaS entity back to UTF-8 text.
 *
 * Returns an empty string for anything that is not decodable rather than
 * throwing: the value comes from the catalog and a broken one must not take the
 * whole form down.
 */
const decodeBase64 = (encodedStr: string): string => {
  try {
    if (typeof encodedStr !== 'string' || !encodedStr) {
      return '';
    }
    const binary = atob(encodedStr);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return '';
  }
};

export const convertEntityToApplication = (entity: Entity) => {
  return {
    applicationName: entity?.spec?.applicationName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    project: {
      project: entity?.spec?.projectId,
      cluster: entity?.spec?.clusterConfig,
    },
    syncPolicy: entity?.spec?.syncPolicy,
    applicationMetadata: entity?.spec?.applicationMetadata,
  };
};

export const convertEntityToApplicationSet = (entity: Entity) => {
  return {
    applicationSetName: entity?.spec?.applicationSetName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    generators: decodeBase64(String(entity?.spec?.generators || '')),
    project: {
      appNameTemplate: entity?.spec?.appNameTemplate,
      project: entity?.spec?.projectId,
      cluster: entity?.spec?.clusterConfig,
      templatePatch: entity?.spec?.templatePatch
        ? decodeBase64(String(entity?.spec?.templatePatch))
        : null,
    },
    syncPolicy: entity?.spec?.syncPolicy,
    applicationMetadata: entity?.spec?.applicationMetadata,
  };
};

/**
 * Re-exported from the project form rather than re-implemented here.
 *
 * This file used to carry a second copy that had fallen behind: it omitted
 * `cicdOidcSubjects` and the legacy `spec.githubActionsSubjects` fallback, so
 * an edit routed through this picker silently dropped every OIDC subject grant
 * the project had.
 */
export { convertEntityToProject } from '../DaasProjectInput/utils';
